require('./_set-species')('Array');


// WEBPACK FOOTER //
// ./~/core-js/modules/es6.array.species.js